module.exports = __webpack_public_path__ + "static/img/25.f9e79b19.jpg";